import { getCitationFormatOptions, SupportedStyleKey } from "@/hooks/useCiteproc";
import * as React from "react"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import { ChevronDown } from "lucide-react";
import { useWorkflowI18n } from "@/hooks/useI18n";

export type CiteprocSelectOption = {
  value: string;
  label: string;
};

export type CiteprocSelectProps = {
  value: SupportedStyleKey;
  onChange: (value: SupportedStyleKey) => void;
  options?: CiteprocSelectOption[];
  triggerClassName?: string;
}
export function CiteprocSelect({ value, onChange, options: externalOptions, triggerClassName }: CiteprocSelectProps) {
  const { t, i18n } = useWorkflowI18n();
  const internalOptions = React.useMemo(() => getCitationFormatOptions(i18n.language), [i18n.language]);
  const options = externalOptions || internalOptions;

  const validValue = React.useMemo(() => {
    const optionValues = options.map(opt => opt.value);
    if (optionValues.includes(value)) {
      return value;
    }
    // options 未就绪时不要回退为第一项，避免覆盖 list 接口下发的当前样式
    if (value) {
      return value;
    }
    return optionValues[0] as SupportedStyleKey;
  }, [value, options]);

  return (
    <Select value={validValue} onValueChange={(v) => onChange(v as SupportedStyleKey)}>
      <SelectTrigger className={triggerClassName || "w-[180px] flex items-center justify-between"}>
        <SelectValue placeholder={t('workflowDetailView.selectCitationFormat')} />
        <ChevronDown className="ml-1 h-4 w-4 text-muted-foreground" />
      </SelectTrigger>
      <SelectContent>
        {
          options.map(({ label, value }) => (
            <SelectItem key={value} value={value}>{label}</SelectItem>
          ))
        }
      </SelectContent>
    </Select>
  )
}

